import React from 'react';

import { EnglishFlagSvg } from './EnglishFlagSvg';
import { FranceFlagSvg } from './FranceFlagSvg';
import { GermanFlagSvg } from './GermanFlagSvg';
import { ItalianFlagSvg } from './ItalianFlagSvg';
import { PortugueseFlagSvg } from './PortugueseFlagSvg';
import { SpanishFlagSvg } from './SpanishFlagSvg';
import { LanguageCodesEnum } from '@constants';

export interface IFlagIconSvgProps {
  langCode: LanguageCodesEnum;
}

export function FlagIconSvg(props: IFlagIconSvgProps) {
  switch (props.langCode) {
    case LanguageCodesEnum.En: {
      return <EnglishFlagSvg />;
    }
    case LanguageCodesEnum.Fr: {
      return <FranceFlagSvg />;
    }
    case LanguageCodesEnum.De: {
      return <GermanFlagSvg />;
    }
    case LanguageCodesEnum.It: {
      return <ItalianFlagSvg />;
    }
    case LanguageCodesEnum.Pt: {
      return <PortugueseFlagSvg />;
    }
    case LanguageCodesEnum.Es: {
      return <SpanishFlagSvg />;
    }
    default: {
      return null;
    }
  }
}
